import {type List} from 'immutable';

import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'FEED_SETTINGS';

import {type BlockedSender} from './reducer';

export const {
    action: fetchBlocked,
    success: fetchBlockedSuccess,
    failed: fetchBlockedFailed,
} = createAction(
    `${domain}/FETCH_BLOCKED_SENDERS`,
    () => ({}),
    (blocked: List<BlockedSender>) => ({blocked}),
);

export const {
    action: unblockSender,
    success: unblockSenderSuccess,
    failed: unblockSenderFailed,
} = createAction(
    `${domain}/UNBLOCK_SENDER`,
    (id: BlockedSender['sender']['id']) => ({id}),
    (id: BlockedSender['sender']['id']) => ({id}),
    (id: BlockedSender['sender']['id']) => ({id}),
);
